import React from "react";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import perksNearMe from "@irati/ui/images/perks-near-me.svg";
import Flex from "@irati/ui/src/Flex";
import { Body, H2 } from "@irati/ui/src/Typography";
import { HeaderWrapper, Image } from "./styled";
var PerksNearMeHeader = function () { return (React.createElement(Flex, { alignItems: "center" },
    React.createElement(Image, { src: perksNearMe }),
    React.createElement(HeaderWrapper, null,
        React.createElement(H2, null,
            React.createElement(FormattedMessage, { id: "perks.searchByLocation.perksGONearMe.header" })),
        React.createElement(Body, { small: true, margin: [1, 0, 0] },
            React.createElement(FormattedMessage, { id: "perks.searchByLocation.perksGONearMe.subheader" }))))); };
export default React.memo(injectIntl(PerksNearMeHeader));
